@if (showNotification) {
  <div class="backend-status-notification">
    <div class="notification-header">
      <i [class]="iconClass" class="notification-icon"></i>
      <h3>{{ title }}</h3>
    </div>

    <div class="notification-content">
      <p>{{ message }}</p>

      @if (showRetry) {
        <div class="retry-info">
          <span class="retry-counter">Retry count: {{ displayedAttempt }}/{{ maxAttempts }}</span>
          @if (timeUntilRetry > 0) {
            <span class="retry-timer">
              Next retry in {{ timeUntilRetry }}s
            </span>
          }
        </div>
      }

      <p class="notification-support">
        If the issue persists, please <a [href]="contactUrl" target="_blank" rel="noopener noreferrer">contact us</a>.
      </p>
    </div>

    @if (showActions) {
      <div class="notification-actions">
        @if (showRetry) {
          <button
            pButton
            type="button"
            icon="pi pi-refresh"
            label="Retry Now"
            (click)="onRetry()"
            class="p-button-raised p-button-warning"
          ></button>
        }
        <button
          pButton
          type="button"
          icon="pi pi-times"
          label="Dismiss"
          (click)="onDismiss()"
          class="p-button-text"
        ></button>
      </div>
    }
  </div>
}
